import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useParams } from "react-router-dom";
import Table from "../../../../../../Components/Table";
import moment from "moment";
import "moment/locale/pt-br";
import {
    ExecutarReguaController,
    GetReguaController,
    ListarDadosAcoesEtapaBaixarExcelController,
    ListarDadosAcoesEtapaController,
    ListarFiltrosAcaoEtapaController,
    ListarOrdenacaoEtapaController,
} from "../../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import {
    IAcoesReguaEtapa,
    IDadosReguaEtapa,
    IOrdenacaoReguaEtapa,
    IRegua,
    IReguaEtapaAcaoFiltro,
} from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import saveAs from "file-saver";
import filterFactory, {
    dateFilter,
    textFilter,
} from "react-bootstrap-table2-filter";

interface IProps {
    row: IAcoesReguaEtapa;
}

export default function ModalVisualizarDados(props: IProps) {
    const { IdRegua } = useParams<{ IdRegua: string }>();
    const [LstOrdenacaoEtapaRegua, setLstOrdenacaoEtapaRegua] = useState<
        Array<IOrdenacaoReguaEtapa>
    >([]);
    const [DadosRegua, setDadosRegua] = useState<IRegua>();
    const [LstEtapaAcaoFiltro, setLstEtapaAcaoFiltro] = useState<
        Array<IReguaEtapaAcaoFiltro>
    >([]);
    const [LstDadosAcaoEtapa, setLstDadosAcaoEtapa] = useState<
        Array<IDadosReguaEtapa>
    >([]);
    const [Loading, setLoading] = useState(true);

    const [filteredData, setFilteredData] =
        useState<Array<IDadosReguaEtapa>>(LstDadosAcaoEtapa);

    const [isFiltered, setIsFiltered] = useState(false);

    moment.locale("pt-br");

    useEffect(() => {
        setLoading(true);
        ListarFiltrosAcaoEtapaController(
            props.row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO
        ).then((res) => {
            setLstEtapaAcaoFiltro(res);
        });

        GetReguaController(Number.parseInt(IdRegua)).then((res) => {
            setDadosRegua(res);
        });
        ListarOrdenacaoEtapaController(
            props.row.ID_CASO_COBRANCA_REGUA_ETAPA
        ).then((res) => {
            setLstOrdenacaoEtapaRegua(res);
        });

        ListarDadosAcoesEtapaController(
            props.row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO,
            props.row.DS_TIPO_ACAO
        )
            .then((res) => {
                setLstDadosAcaoEtapa(res);
                setLoading(false);
                setIsFiltered(false);
            })
            .catch(() => {
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        IdRegua,
        props.row.DS_TIPO_ACAO,
        props.row.ID_CASO_COBRANCA_REGUA_ETAPA,
        props.row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO,
    ]);

    const rowexec = (cell: any, row: IDadosReguaEtapa) => {
        return (
            <div>
                {props.row.DS_TIPO_ACAO === "Distribuição" && (
                    <button
                        type="button"
                        className="btn btn-light-success font-weight-bold ml-2"
                        onClick={() => {
                            ExecutarReguaController(
                                [{ ...row }],
                                props.row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO
                            );
                        }}
                    >
                        <FontAwesomeIcon icon={faBolt} size="sm" />
                    </button>
                )}
            </div>
        );
    };

    const rowCliente = (cell: any, row: IDadosReguaEtapa) => {
        return <div>{row.DS_CLIENTE ? row.DS_CLIENTE : "-"}</div>;
    };

    const rowCPF = (cell: any, row: IDadosReguaEtapa) => {
        return <div>{row.NR_CPF ? row.NR_CPF : "-"}</div>;
    };

    const rowEmail = (cell: any, row: IDadosReguaEtapa) => {
        return <div>{row.DS_EMAIL ? row.DS_EMAIL : "-"}</div>;
    };
    const rowTelefone = (cell: any, row: IDadosReguaEtapa) => {
        return <div>{row.NR_TELEFONE ? row.NR_TELEFONE : "-"}</div>;
    };
    const rowEmpresa = (cell: any, row: IDadosReguaEtapa) => {
        return <div>{row.ID_EMPRESA ? row.ID_EMPRESA : "-"}</div>;
    };
    const rowObra = (cell: any, row: IDadosReguaEtapa) => {
        return <div>{row.ID_OBRA ? row.ID_OBRA : "-"}</div>;
    };
    const rowVenda = (cell: any, row: IDadosReguaEtapa) => {
        return <div>{row.ID_VENDA ? row.ID_VENDA : "-"}</div>;
    };
    const rowIdentificador = (cell: any, row: IDadosReguaEtapa) => {
        return <div>{row.DS_IDENTIFICADOR ? row.DS_IDENTIFICADOR : "-"}</div>;
    };
    const rowDtVenda = (cell: any, row: IDadosReguaEtapa) => {
        return (
            <>
                <div>
                    {row.DT_CONTRATO
                        ? moment(row.DT_CONTRATO).format("DD/MM/YYYY")
                        : "-"}
                </div>
            </>
        );
    };

    const MAX_FILTER_LENGTH = 100;

    const handleFilter = (filterValue: any, key: keyof IDadosReguaEtapa) => {
        setLoading(true);
        if (filterValue) {
            setIsFiltered(true);
            setFilteredData(
                LstDadosAcaoEtapa.filter((row) => {
                    return row[key]
                        ?.toString()
                        .toLowerCase()
                        .includes(
                            filterValue
                                .toString()
                                .substring(0, MAX_FILTER_LENGTH)
                                .trim()
                                .toLowerCase()
                        );
                })
            );
        } else {
            setIsFiltered(false);
            setFilteredData(LstDadosAcaoEtapa);
        }
        setLoading(false);
    };

    const handleDateFilter = (
        filterValue: any,
        key: keyof IDadosReguaEtapa
    ) => {
        setLoading(true);
        if (filterValue) {
            setIsFiltered(true);
            const filterDate = new Date(filterValue);

            const filtered = LstDadosAcaoEtapa.filter((row: any) => {
                const rowDate = new Date(row[key]);

                return (
                    rowDate.toISOString().split("T")[0] ===
                    filterDate.toISOString().split("T")[0]
                );
            });

            if (filtered && filtered.length > 0) {
                setIsFiltered(true);
                setFilteredData(filtered);
            } else {
                setIsFiltered(true);
                setFilteredData([]);
            }
        } else {
            setIsFiltered(false);
            setFilteredData(LstDadosAcaoEtapa);
        }
        setLoading(false);
    };

    const headerFormatter = (
        column: any,
        colIndex: any,
        { sortElement, filterElement }: any
    ) => {
        return (
            <div className="d-flex flex-column">
                <span>{column.text}</span>
                {filterElement}
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "",
            text: "Executar",
            formatter: rowexec,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "DS_CLIENTE",
            text: "Cliente",
            formatter: rowCliente,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) => {
                    handleFilter(filterValue.toString(), "DS_CLIENTE");
                },
            }),
        },
        {
            dataField: "NR_CPF",
            text: "CPF",
            formatter: rowCPF,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    handleFilter(filterValue.toString(), "NR_CPF"),
            }),
        },
        {
            dataField: "DS_EMAIL",
            text: "Email",
            formatter: rowEmail,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    handleFilter(filterValue.toString(), "DS_EMAIL"),
            }),
        },
        {
            dataField: "NR_TELEFONE",
            text: "Telefone",
            formatter: rowTelefone,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    handleFilter(filterValue.toString(), "NR_TELEFONE"),
            }),
        },
        {
            dataField: "ID_EMPRESA",
            text: "Empresa",
            formatter: rowEmpresa,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    handleFilter(filterValue.toString(), "ID_EMPRESA"),
            }),
        },
        {
            dataField: "ID_OBRA",
            text: "Obra",
            formatter: rowObra,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    handleFilter(filterValue.toString(), "ID_OBRA"),
            }),
        },
        {
            dataField: "ID_VENDA",
            text: "Venda",
            formatter: rowVenda,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    handleFilter(filterValue.toString(), "ID_VENDA"),
            }),
        },
        {
            dataField: "DS_IDENTIFICADOR",
            text: "Identificador",
            formatter: rowIdentificador,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    handleFilter(filterValue.toString(), "DS_IDENTIFICADOR"),
            }),
        },
        {
            dataField: "DT_VENDA",
            text: "Data Venda",
            formatter: rowDtVenda,
            headerFormatter,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
            filter: dateFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) => {
                    const selectedDate = filterValue as any;

                    if (selectedDate && selectedDate.date) {
                        const adjustedDate = new Date(
                            selectedDate.date.getTime() +
                                selectedDate.date.getTimezoneOffset() * 60000
                        );
                        handleDateFilter(adjustedDate, "DT_CONTRATO");
                    } else {
                        handleDateFilter("", "DT_CONTRATO");
                    }
                },
                comparatorStyle: { display: "none" },
            }),
        },
    ];

    return (
        <>
            <div className="d-flex flex-wrap flex-row justify-content-between mr-1 w-100">
                <div className="col-md-6">
                    <div className="d-flex flex-wrap flex-row align-itens-center mr-1">
                        <div>
                            {LstEtapaAcaoFiltro.length ? (
                                <span className="d-block font-weight-bold ">
                                    Filtro:
                                </span>
                            ) : (
                                <div></div>
                            )}

                            {LstEtapaAcaoFiltro &&
                                LstEtapaAcaoFiltro.map((etapaAcao) => {
                                    return (
                                        <div>
                                            <div
                                                key={
                                                    etapaAcao.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO
                                                }
                                                className="d-flex flex-wrap flex-row align-itens-center mr-1"
                                            >
                                                <span className="label label-light-dark  label-inline mr-2 my-1">
                                                    <span className="label label-light-dark  label-inline m-1 p-0">
                                                        {
                                                            etapaAcao.DS_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO
                                                        }
                                                    </span>
                                                    <span className="label label-light-dark  label-inline m-1 p-0">
                                                        {etapaAcao.DS_OPERACAO}
                                                    </span>
                                                    <OverlayTrigger
                                                        overlay={
                                                            etapaAcao.DS_VALOR
                                                                .length > 40 ? (
                                                                <Tooltip id="tooltip-disabled">
                                                                    {
                                                                        etapaAcao.DS_VALOR
                                                                    }
                                                                </Tooltip>
                                                            ) : (
                                                                <div></div>
                                                            )
                                                        }
                                                    >
                                                        <span className="label label-light-dark  label-inline m-1 p-0">
                                                            {etapaAcao.DS_VALOR
                                                                .length > 40
                                                                ? etapaAcao.DS_VALOR.substring(
                                                                      0,
                                                                      40
                                                                  ) + "..."
                                                                : etapaAcao.DS_VALOR}
                                                        </span>
                                                    </OverlayTrigger>
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-itens-center mr-1">
                        <div>
                            {LstOrdenacaoEtapaRegua.length ? (
                                <span className="d-block font-weight-bold ">
                                    Ordenação:
                                </span>
                            ) : (
                                <div></div>
                            )}

                            {LstOrdenacaoEtapaRegua &&
                                LstOrdenacaoEtapaRegua.map((itemOrdem) => {
                                    return (
                                        <div>
                                            <span className="label label-light-dark  label-inline mr-2 my-1">
                                                {"("} {itemOrdem.NR_ORDEM}{" "}
                                                {") -"}{" "}
                                                {itemOrdem.DS_CAMPO.replace(
                                                    "_",
                                                    " "
                                                )}{" "}
                                                -{" "}
                                                {itemOrdem.FL_ORDEM_CRESCENTE
                                                    ? " ASCENDENTE"
                                                    : " DESCENDENTE"}
                                            </span>{" "}
                                            <br />
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="d-flex flex-wrap flex-row align-itens-center mr-1">
                        <div>
                            <span className="d-block font-weight-bold ">
                                Régua:
                            </span>
                            <span className="label label-light-dark  label-inline mr-2 my-1">
                                {DadosRegua?.DS_NOME_REGUA}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-itens-center mr-1">
                        <div>
                            <span className="d-block font-weight-bold ">
                                Etapa:
                            </span>
                            <span className="label label-light-dark  label-inline mr-2 my-1">
                                {props.row.DS_NOME_ETAPA}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-itens-center mr-1">
                        <div>
                            <span className="d-block font-weight-bold ">
                                Ação:
                            </span>
                            <span className="label label-light-dark  label-inline mr-2 my-1">
                                {props.row.DS_NOME_ACAO}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-itens-center mr-1">
                        <div>
                            <span className="d-block font-weight-bold ">
                                Tipo Ação:
                            </span>
                            <span className="label label-light-dark  label-inline mr-2 my-1">
                                {props.row.DS_TIPO_ACAO}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap flex-row align-itens-center mt-2">
                        {props.row.DS_TIPO_ACAO === "Distribuição" && (
                            <button
                                type="button"
                                className="btn btn-light-primary font-weight-bold"
                                disabled={!LstDadosAcaoEtapa.length}
                                onClick={() => {
                                    ExecutarReguaController(
                                        LstDadosAcaoEtapa,
                                        props.row
                                            .ID_CASO_COBRANCA_REGUA_ETAPA_ACAO
                                    );
                                }}
                            >
                                Executar Régua geral{" "}
                                <FontAwesomeIcon icon={faBolt} size="sm" />
                            </button>
                        )}
                        <button
                            type="button"
                            className="btn btn-light-primary font-weight-bold ml-3"
                            onClick={() => {
                                ListarDadosAcoesEtapaBaixarExcelController(
                                    props.row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO,
                                    props.row.DS_TIPO_ACAO,
                                    true
                                ).then((res) => {
                                    saveAs(
                                        new Blob([res], {
                                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                        }),
                                        "Dados Régua.xlsx"
                                    );
                                });
                            }}
                        >
                            Baixar Excel{" "}
                            <FontAwesomeIcon icon={faFileExcel} size="sm" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="card card-custom w-auto gutter-b m-5">
                {
                    <Table
                        columns={columns}
                        data={
                            filteredData.length > 0 || isFiltered
                                ? filteredData
                                : LstDadosAcaoEtapa
                        }
                        keyField={"ID_VENDA"}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhum dado encontrado
                            </div>
                        )}
                        noSearch
                        wrapperClasses={
                            "mw-100 maxHeight-300 custom-scroll mb-5"
                        }
                        headerClasses={"sticky-thead"}
                        loading={Loading}
                        sizePerPage={10}
                        filter={filterFactory()}
                    />
                }
            </div>
        </>
    );
}
